import React from "react";
import PropTypes from "prop-types";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconFormato from "../Icons/IconFormato";
import IconAccesoCV from "../Icons/IconAccesoCV";
import IconIdioma from "../Icons/IconIdioma";
import IconDuracion from "../Icons/IconDuracion";
import IconFechaInicio from "../Icons/IconFechaInicio";
import IconDyH from "../Icons/IconDyH";
import IconProyectos from "../Icons/IconProyectos";
import IconCasos from "../Icons/IconCasos";

const ProgramSpecs = ({ programs }) => {
    const renderIcon = (key) => {
        switch (key) {
            case 'FORMATO':
                return <IconFormato width={60} height={60} />;
            case 'ACCESO_CV':
                return <IconAccesoCV width={60} height={60} />;
            case 'IDIOMA':
                return <IconIdioma width={60} height={60} />;
            case 'DURACION':
                return <IconDuracion width={60} height={60} />;
            case 'FECHA_INICIO':
                return <IconFechaInicio width={60} height={60} />;
            case 'DIA_Y_HORA':
                return <IconDyH width={60} height={60} />;
            case 'PROYECTOS':
                return <IconProyectos width={60} height={60} />;
            case 'CASOS':
                return <IconCasos width={60} height={60} />;
            default:
                return null;
        }
    }

    return (
        <Container fluid tag="section" className="program-specs py-5">
            <Container>
                <Row className="pb-5">
                    <Col className="text-center">
                        <h2 className="title">Características del programa</h2>
                    </Col>
                </Row>
                <Row className="align-items-baseline">
                    {programs.map((program, index) => (
                        <Col sm="6" md="4" lg="3" key={index} className="text-center program-specs__item">
                            {renderIcon(program.key)}
                            <h3>{program.title}</h3>
                            <p>{program.content}</p>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    )
};

ProgramSpecs.defaultProps = {
    programs: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ProgramSpecs;